export default `<!-- SparkLayer product price script-->
<spark-product-price parent-id="<?php echo absint( $product->get_id() ); ?>"></spark-product-price>
<!-- Hide any element by adding data-spark="b2c-only" to it, e.g. -->
<div data-spark="b2c-only">
    <!-- This would hide anything inside-->
</div>
`;
